import e from "../../../../../_virtual/index.js";
const p = e.oneOfType([e.func, e.object]);
export {
  p as default
};
